// Auth
export const ROUTING_LOGIN = "/login";

// Dashboard
export const ROUTING_HOME = "/";
export const ROUTING_CHATBOT = "/chatbot";

const ROUTES = {
  LOGIN: ROUTING_LOGIN,
  HOME: ROUTING_HOME,
  CHATBOT: ROUTING_CHATBOT
};

export default ROUTES;
